import { render } from "./search.vue?vue&type=template&id=78872e51"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
script.render = render

export default script